
import { onUnmounted, onMounted, inject } from 'vue'
import { noScroll, refreshScroll } from '../../assets/js/utils.js'
export default {
  name: 'AioConfirm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    confirmInfo: {
      type: Object,
      default: () => ({
        title: '',
        detail: ''
      })
    },
    reportDataMap: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['doClose'],
  setup(props, { emit }) {
    const $xesLog = inject('$xesLog') as any // 埋点
    const reportData = {
      page_name: props.reportDataMap?.page_name
    }
    onMounted(() => {
      noScroll()
    })
    onUnmounted(() => {
      refreshScroll()
      emit('doClose')
    })
    const doConfirm = () => {
      refreshScroll()
      props.confirmInfo.doConfirm()
    }
    const doClose = (type) => {
      refreshScroll()
      props.confirmInfo.doClose()
    }
    return {
      doClose,
      doConfirm
    }
  }
}
